export default __webpack_public_path__ + "static/media/bigLogo.41ae9b18.svg";